import { PRIO } from '../../../constants';

export const OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER =
  PRIO + 'OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER';
export const CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER =
  PRIO + 'CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER';

export interface OpenIndividualAbsenceNoteDrawerAction {
  type: typeof OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER;
}

export interface CloseIndividualAbsenceNoteDrawerAction {
  type: typeof CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER;
}

export type IndividualAbsenceNoteDrawerActions =
  | OpenIndividualAbsenceNoteDrawerAction
  | CloseIndividualAbsenceNoteDrawerAction;

export const openIndividualAbsenceNoteDrawer =
  (): OpenIndividualAbsenceNoteDrawerAction => ({
    type: OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER,
  });

export const closeIndividualAbsenceNoteDrawer =
  (): CloseIndividualAbsenceNoteDrawerAction => ({
    type: CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER,
  });
